var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVoiceCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14.14V9.85c0-.41.34-.75.75-.75s.75.34.75.75v4.29a.749.749 0 1 1-1.5 0zM8.25 15.57V8.43c0-.41.34-.75.75-.75s.75.34.75.75v7.14a.749.749 0 1 1-1.5 0zM11.25 17V7c0-.41.34-.75.75-.75s.75.34.75.75v10c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.25 15.57V8.43c0-.41.34-.75.75-.75s.75.34.75.75v7.14a.749.749 0 1 1-1.5 0zM17.25 14.14V9.85c0-.41.34-.75.75-.75s.75.34.75.75v4.29a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVoiceCricle);
export default __webpack_public_path__ + "static/media/vuesax-outline-voice-cricle.76d852736837a89c00ec93ff49fd46f7.svg";
export { ForwardRef as ReactComponent };